// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import CreateUserForm from "../../../components/CreateUser.js";

const CreateUser = () => {
  return (
    <>
      <Header
        title="Create User"
        description="This is the user creation page. You can create a new user here."
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col-xl-9">
            <CreateUserForm />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default CreateUser;
